import { SkillAssignment } from "../Person/SkillAssignment";

export interface IUnifiedClassPersonSkill {
  assignId: number;
  personId: number;
  skillId: number;
  skillName: string;
  skillActive: boolean;
  skillDisplayOrder: number;
  assessmentId: number;
  assessmentName: string;
  dateChanged: string | null;
  instructor: string | null;
  comments: string | null;
  jpClassSignupsSkillsAssignId: number | null;
}

export class UnifiedClassPersonSkill implements IUnifiedClassPersonSkill {
  assignId: number;
  personId: number;
  skillId: number;
  skillName: string;
  skillActive: boolean;
  skillDisplayOrder: number;
  assessmentId: number;
  assessmentName: string;
  dateChanged: string | null;
  instructor: string | null;
  comments: string | null;
  jpClassSignupsSkillsAssignId: number | null;

  constructor(config: IUnifiedClassPersonSkill) {
    this.assignId = config.assignId;
    this.personId = config.personId;
    this.skillId = config.skillId;
    this.skillName = config.skillName;
    this.skillActive = config.skillActive;
    this.skillDisplayOrder = config.skillDisplayOrder;
    this.assessmentId = config.assessmentId;
    this.assessmentName = config.assessmentName;
    this.dateChanged = config.dateChanged;
    this.instructor = config.instructor;
    this.comments = config.comments;
    this.jpClassSignupsSkillsAssignId = config.jpClassSignupsSkillsAssignId;
  }

  toSkillAssignment() {
    return new SkillAssignment({
      skill: this.skillId,
      rating: this.assessmentId,
      instructor: this.instructor,
      comment: this.comments,
    });
  }
}
